import { render, staticRenderFns } from "./ListTipoPage.vue?vue&type=template&id=bbff914e"
import script from "./ListTipoPage.vue?vue&type=script&lang=js"
export * from "./ListTipoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports